import { render, staticRenderFns } from "./add.vue?vue&type=template&id=7f1b25da&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f1b25da')) {
      api.createRecord('7f1b25da', component.options)
    } else {
      api.reload('7f1b25da', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=7f1b25da&", function () {
      api.rerender('7f1b25da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/complaintManage/suggestList/add.vue"
export default component.exports